import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  * {
    white-space: nowrap;
  }
`;

export const Label = styled.div`
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 1px;
`;

export const Text = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 1px;
`;

export const Component = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
`;
export const ComponentKey = styled.div`
  text-transform: capitalize;
  font-weight: 600;
  width: 80px;
`;

export const ComponentValue = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 1px;
  flex: 1;
`;

export const ProfileType = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
`;

export const ProfileTypeLabel = styled.div`
  flex: 1;
`;
export const CallStat = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
`;

export const CallStatType = styled.div`
  width: 40px;
`;
export const CallStatValue = styled.div`
  flex: 1;
  font-weight: 600;
`;
export const CallStatPercent = styled.div`
  width: 70px;
  text-align: right;
`;

export const Footer = styled.div`
  white-space: break-spaces;
  color: var(--theme-neutral-400);
`;

export const Comparison = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  max-width: 100%;
  overflow: hidden;
`;
export const ComparisonSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
`;
export const ComparisonSideLabel = styled.div`
  font-weight: 800;
`;

export const ScaleCursorWidth = 100;
export const ScaleWidth = 400;
export const Scale = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
export const ScaleInner = styled.div`
  height: 40px;
  position: relative;
  width: ${ScaleWidth}px;
`;
export const ScaleBackground = styled.div`
  display: flex;
  gap: 2px;
`;
export const ScaleBackgroundCell = styled.div<{ delta: number | undefined }>`
  background-color: ${({ delta }) =>
    (delta ?? 0) > 0 ? "var(--color-red-500)" : "var(--color-java-500)"};
  height: 20px;
  flex: 1;
}
`;
export const ScaleText = styled.div`
  font-size: 12px;
  line-height: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  margin-left: -${ScaleCursorWidth / 2}px;
  position: absolute;
  top: 22px;
  width: ${ScaleCursorWidth}px;
`;

export const ScaleTextLabel = styled.div`
  text-align: center;
  width: ${ScaleCursorWidth}px;
`;
export const ScaleTextMarker = styled.div`
  height: 10px;

  &::before {
    border-style: solid;
    border-color: var(--mode-text-neutral-default);
    border-width: 2px 2px 0 0;
    content: "";
    display: inline-block;
    height: 5px;
    position: relative;
    top: 2px;
    transform: rotate(-45deg);
    vertical-align: top;
    width: 5px;
  }
`;
